<template>
    <div class="column items-center p-qa-sm">
        <div class="text-center">
            <img :src="ErrorImage" alt="error_image" />
            <div class="box">
                <h3 class="message">{{ $t("mechanic.The search did not match any results") }}</h3>
                <div class="flex flex-start">{{ $t("mechanic.Possible causes") }}:</div>
                <ul class="inline-block">
                    <li class="text-left">
                        {{
                            $t(
                                "mechanic.You do not have the required rights to view possible search hits Please contact the administrator of your InfoTwin"
                            )
                        }}
                    </li>
                    <li class="text-left">
                        {{
                            $t(
                                "mechanic.The photo used is not recognizable Photograph the object from a different angle Make sure the lighting is good"
                            )
                        }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import ErrorImage from "@/shared/components/placeholder/assets/images/lost_gear_wheel.svg?url";
</script>

<style lang="scss" scoped>
.box {
    max-width: 500px;
}
img {
    .screen--xs &,
    .screen--md {
        max-height: 15vh;
    }
}
</style>
